interface CloseIconProps {
    color?: string;
    fat?: boolean;
    className?: string | null;
}

function CloseIcon({ color = 'currentColor', fat = false, className = null }: CloseIconProps) {
    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="21.4px"
            height="21.4px"
            viewBox="0 0 21.4 21.4"
            xmlSpace="preserve"
            className={className || undefined}
        >
            <g>
                <line
                    fill="none"
                    stroke={color}
                    strokeWidth={fat ? 3 : 2}
                    strokeMiterlimit="10"
                    strokeLinecap="butt"
                    x1="0.7"
                    y1="20.7"
                    x2="20.7"
                    y2="0.7"
                />
                <line
                    fill="none"
                    stroke={color}
                    strokeWidth={fat ? 3 : 2}
                    strokeMiterlimit="10"
                    strokeLinecap="butt"
                    x1="0.7"
                    y1="0.7"
                    x2="20.7"
                    y2="20.7"
                />
            </g>
        </svg>
    );
}

export default CloseIcon;
